import { useMutation } from "@apollo/client";
import React, { useContext, useEffect, useState } from "react";
import { clientPolicyIngsight } from "../../App";
import { ReactComponent as CloneIcon } from "../../assets/svg/add-square-icon.svg";
import {
  CREATE_FORM_QUESTION,
  UPDATE_FORM_QUESTION_STATUS,
} from "../../GraphQL/Mutations";
import MessageYesNo from "../MessageYesNo/index";
import {
  CloneButton,
  DeleteButton,
  GeneralStyle,
  LowerWrapper,
  SelectsSection,
} from "./AttachFileQuestionBlock.styled";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { NotificationManager } from "react-notifications";
import ModalLoader from "../ModalLoader/ModalLoader";

const AttachFileQuestionBlock = (globalProps) => {
  const [openMessageYesNoModal, setOpenMessageYesNoModal] = useState(false);
  const [responseMessageYesNo, setResponse] = useState(false);
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const [questionId, setQuestionId] = useState(globalProps?.GidQuestion);
  const [createFormQuestion] = useMutation(CREATE_FORM_QUESTION, {
    client: clientPolicyIngsight,
  });
  const [updateFormQuestionStatus] = useMutation(UPDATE_FORM_QUESTION_STATUS, {
    client: clientPolicyIngsight,
  });
  const [showLoader, setshowLoader] = useState(false);

  useEffect(() => {
    if (!questionId) {
      saveFormQuestion(false);
    }
  }, [questionId]);

  const handleDeleteQuestion = () => {
    setshowLoader(true);
    if (globalProps.GidQuestion) {
      updateFormQuestionStatus({
        variables: {
          idFormQuestion: globalProps.GidQuestion,
          newFormQuestionStatus: "DELETED",
        },
      })
        .then((res) => {
          if (res?.data?.changeStatusFormQuestion?.idQuestionForm) {
            setshowLoader(false);
            let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
            copy.questions.splice(globalProps.GindexQuestion, 1);
            copy.questions.forEach((q, index) => {
              q.GindexQuestion = index;
              q.Gorder = index + 1;
            });
            dispatch({ type: "CLEAN_QUESTIONS" });
            dispatch({ type: "DELETE_QUESTIONS", payload: copy });
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };
  const saveFormQuestion = (clone) => {
    let copyText = clone ? " - Copy" : "";
    createFormQuestion({
      variables: {
        idForm: globalProps.GidSurvey,
        questionTitle: `File_${globalProps.Gorder}` + copyText,
        questionType: "FILE",
        jsonConfiguration: "",
        isMandatory: false,
        questionOrder: globalProps.Gorder,
      },
    })
      .then((res) => {
        if (res?.data?.createFormQuestion?.idForm) {
          let idQuestion = res.data.createFormQuestion.idQuestionForm;
          if (copyText !== "") {
            dispatch({
              type: "CLONE_QUESTION",
              payload: {
                Gtype: "File",
                GindexQuestion: globalProps.GindexQuestion + 1,
                Gactive: true,
                GidSurvey: globalProps.GidSurvey,
                GidQuestion: idQuestion,
                GidCategoryQuestion: "",
                GnameQuestion: `File_${globalProps.Gorder}` + copyText,
                GvalidationText: "",
                GidQuestionSurvey: idQuestion,
                GisMandatory: false,
                GjsonConfiguration: "",
                Gorder: globalProps.Gorder + 1,
                GisEdit: false,
                GisDependent: false,
                GidParentQuestion: null,
                GdependentAnswer: null,
                clonePosition: globalProps.GindexQuestion + 1,
              },
            });
          } else {
            setQuestionId(idQuestion);
            dispatch({
              type: "SAVE_QUESTIONS",
              payload: {
                GindexQuestion: globalProps.GindexQuestion,
                GisEdit: false,
                GnameQuestion: `File_${globalProps.Gorder}`,
                GidCategoryQuestion: "",
                GisMandatory: false,
                Gorder: globalProps.Gorder,
                GvalidationText: "",
                GidQuestion: idQuestion,
                GidQuestionSurvey: idQuestion,
                GjsonConfiguration: "",
              },
            });
          }
          setshowLoader(false);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  useEffect(() => {
    if (responseMessageYesNo) {
      handleDeleteQuestion();
    }
  }, [responseMessageYesNo]);

  return (
    <>
      <GeneralStyle>
        <LowerWrapper>
          <SelectsSection>
            <div>
              <input type="file" accept="application/pdf" />
            </div>
          </SelectsSection>
        </LowerWrapper>
        {questionId && (
          <div className="overlay-option">
            <div className="bottom-buttons">
              <CloneButton
                hidden={globalProps.disableButton}
                className="mx-3 w-25 mt-2 mb-3"
                onClick={() => saveFormQuestion(true)}
              >
                <CloneIcon />
                Clone
              </CloneButton>
              <DeleteButton
                hidden={globalProps.disableButton}
                className="mx-3 w-25 mt-2 mb-3"
                onClick={() => setOpenMessageYesNoModal(true)}
              >
                Delete
              </DeleteButton>
            </div>
          </div>
        )}
        {openMessageYesNoModal && (
          <MessageYesNo
            setOpenMessageYesNoModal={setOpenMessageYesNoModal}
            message="Are you sure you want to delete this question?"
            setResponse={setResponse}
          ></MessageYesNo>
        )}
        {showLoader && <ModalLoader />}
      </GeneralStyle>
    </>
  );
};

export default AttachFileQuestionBlock;
